import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import Icon from '../../../components/AppIcon';
import { useTranslation } from '../../../i18n';

const BankDetailsSection = ({ bank }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  if (!bank?.bankName) return null;

  const copyAccount = () => {
    navigator.clipboard.writeText(bank.accountNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 lg:p-8 shadow-romantic-md border border-border">
      <div className="text-center mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-3">
          <Icon name="Gift" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-2">
          {t('bank.weddingGift')}
        </h3>
        <p className="text-sm text-muted-foreground">
          {t('bank.giftMessage')}
        </p>
      </div>

      <div className="bg-background rounded-lg border border-border overflow-hidden">
        <div className="px-4 py-3 bg-primary/10 border-b border-primary/20">
          <p className="text-xs md:text-sm font-semibold text-primary uppercase tracking-wider">
            {t('bank.bankTransfer')}
          </p>
        </div>
        <div className="p-4 md:p-5 space-y-4">
          <div>
            <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">
              {t('bank.bankName')}
            </p>
            <p className="text-sm md:text-base font-medium text-foreground">
              {bank.bankName}
            </p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">
              {t('bank.accountNumber')}
            </p>
            <div className="flex items-center gap-2">
              <span className="font-mono text-sm md:text-base text-foreground border border-dashed border-border px-3 py-2 rounded flex-1">
                {bank.accountNumber}
              </span>
              <button
                type="button"
                onClick={copyAccount}
                className="p-2 text-primary hover:bg-primary/10 rounded-lg transition-romantic"
                title={t('bank.copyAccount')}
              >
                {copied ? (
                  <Check className="w-5 h-5 text-green-500" />
                ) : (
                  <Copy className="w-5 h-5" />
                )}
              </button>
            </div>
          </div>
          <div>
            <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">
              {t('bank.accountHolder')}
            </p>
            <p className="text-sm md:text-base font-medium text-foreground">
              {bank.accountHolder}
            </p>
          </div>
          {bank.qrCodeUrl && (
            <div className="pt-4 border-t border-border">
              <p className="text-xs text-muted-foreground uppercase tracking-wider mb-3 text-center">
                {t('bank.qrPayment')}
              </p>
              <div className="flex justify-center">
                <img
                  src={bank.qrCodeUrl}
                  alt={t('bank.qrCode')}
                  className="w-40 h-40 md:w-48 md:h-48 rounded-lg border border-border"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BankDetailsSection;
